export const zoomOptions = {
    zoom: {
      wheel: {
        enabled: false,
      },
      pinch: {
        enabled: false,
      },
      drag: {
        enabled: false
      },
      mode: 'x',
    },
    pan: {
      enabled: false,
      mode: 'x',
      modifierKey: 'ctrl',
    },
    limits: {
      x: { max: 'original' },
    },
  };